import { BASE_URL, API_VERSION } from "../constants/url";

export const getApiCall = async ({ url, dispatch }) => {
  let finalUrl = `${BASE_URL}api/${API_VERSION}/${url}`;
  let token = localStorage.getItem("alrounderToken");
  try {
    const response = await fetch(finalUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    return await response.json();
  } catch (error) {
    console.log("error here", error);
  }
};

export const genericApiCall = async ({ url, method, data, ContentType }) => {
  let finalUrl = `${BASE_URL}api/${API_VERSION}/${url}`;
  let token = localStorage.getItem("alrounderToken");
  let headers = {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    // "Content-Type": "application/json",
  };
  if (ContentType) {
    headers = {
      ...headers,
      "Content-Type": ContentType,
    };
  }
  try {
    const response = await fetch(finalUrl, {
      method: method,
      headers: headers,
      body: data,
      redirect: "follow",
    });
    return await response.json();
  } catch (error) {
    console.log("error here", error);
  }
};

export const rawDataApiCall = async ({
  url,
  method,
  data,
  isFormData,
  ContentType,
}) => {
  let finalUrl = `${BASE_URL}api/${API_VERSION}/${url}`;
  let token = localStorage.getItem("alrounderToken");
  // console.log("generic apicall", finalUrl, authToken);

  let headers = {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  };
  if (ContentType) {
    headers = {
      ...headers,
      "Content-Type": ContentType,
    };
  }
  try {
    const response = await fetch(finalUrl, {
      method: method,
      headers: headers,
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log("error here", error);
  }
};
